<template>
  <div>
    <el-card :span="6">
      <el-form ref="searchForm" :model="searchForm">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item label="" prop="name">
              <el-input style="width: 100%;" :size="componentSize" v-model="searchForm.name" placeholder="请输入名称" @keyup.enter.native="pageList" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item>
              <el-button :size="componentSize" type="primary" @click="pageList" icon="el-icon-search">搜索</el-button>
              <el-button :size="componentSize" type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card :span="6" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
        <el-button :size="componentSize" type="primary" @click="goToAddProject" icon="el-icon-plus">新增</el-button>
        <el-button :size="componentSize" type="danger" @click="batchDeleteProject" icon="el-icon-minus">批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
        </el-col>
      </el-row>
      <el-table :size="componentSize" ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                border v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" @selection-change="selectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="cover" label="封面">
          <template slot-scope="scope">
            <img style="width: 100px;" :src="scope.row.cover"/>
          </template>
        </el-table-column>
        <el-table-column prop="subjectName" label="科目"></el-table-column>
        <el-table-column prop="teacherName" label="讲师"></el-table-column>
        <el-table-column prop="mode" label="模式"></el-table-column>
        <el-table-column prop="gradeReward" label="学分奖励"></el-table-column>
        <el-table-column prop="certificateList" label="证书奖励">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.certificateList" :key="index">{{item.name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span @click="$router.push({path: `/editProject?projectId=${scope.row.id}`})"><i class="el-icon-edit" title="编辑"></i></span>
              <span @click="$router.push({path: `/project/userList?projectId=${scope.row.id}`})"><i class="el-icon-user"  title="查看用户"></i></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px;text-align: right;"
                     :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                     @size-change="sizeChange" @current-change="currentChange">
      </el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" :width="addFormDialogWidth" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input style="width: 100%;" :size="componentSize" v-model="addForm.name" placeholder="请输入名称" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="封面" prop="cover">
              <el-input style="width: 100%;" :size="componentSize" v-model="addForm.cover" placeholder="请输入封面" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属科目" prop="subjectId">
              <el-cascader style="width: 100%" clearable v-model="courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门" prop="departmentId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.departmentId" placeholder="请输入部门" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="讲师" prop="teacherId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.teacherId" placeholder="请输入讲师" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预算" prop="budget">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.budget" placeholder="请输入预算" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input style="width: 100%;" :size="componentSize" v-model="addForm.remark" placeholder="请输入备注" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模式" prop="mode">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.mode" placeholder="请输入模式" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展现样式" prop="displayStyle">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.displayStyle" placeholder="请输入展现样式" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习进度" prop="learningRate">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.learningRate" placeholder="请输入学习进度" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学分奖励" prop="gradeReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.gradeReward" placeholder="请输入学分奖励" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书奖励" prop="certificateReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.certificateReward" placeholder="请输入证书奖励" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防挂机" prop="antiHang">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.antiHang" placeholder="请输入防挂机" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防拖拽" prop="antiDrag">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.antiDrag" placeholder="请输入防拖拽" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="倍速播放" prop="timesSpeed">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.timesSpeed" placeholder="请输入倍速播放" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              <el-date-picker style="width: 100%;" :size="componentSize"
                v-model="addForm.createTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                align="right"
                placeholder="选择日期时间"
                :picker-options="pickerOptions" clearable>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人id" prop="operatorId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.operatorId" placeholder="请输入操作人id" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识1：有效 -1：被删除" prop="state">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.state" placeholder="请输入标识1：有效 -1：被删除" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addProject">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="detailFormVisible" :width="detailFormDialogWidth" left>
      <el-form class="detail-form-dialog" ref="detailForm" :model="detailForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              {{detailForm.name}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="封面" prop="cover">
              {{detailForm.cover}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="科目" prop="subjectId">
              {{detailForm.subjectId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门" prop="departmentId">
              {{detailForm.departmentId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="讲师" prop="teacherId">
              {{detailForm.teacherId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预算" prop="budget">
              {{detailForm.budget}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              {{detailForm.remark}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模式" prop="mode">
              {{detailForm.mode}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展现样式" prop="displayStyle">
              {{detailForm.displayStyle}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习进度" prop="learningRate">
              {{detailForm.learningRate}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学分奖励" prop="gradeReward">
              {{detailForm.gradeReward}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书奖励" prop="certificateReward">
              {{detailForm.certificateReward}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防挂机" prop="antiHang">
              {{detailForm.antiHang}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防拖拽" prop="antiDrag">
              {{detailForm.antiDrag}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="倍速播放" prop="timesSpeed">
              {{detailForm.timesSpeed}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              {{detailForm.createTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人id" prop="operatorId">
              {{detailForm.operatorId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识1：有效 -1：被删除" prop="state">
              {{detailForm.state}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" :width="editFormDialogWidth" left>
      <el-form class="edit-form-dialog" ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input style="width: 100%;" :size="componentSize" v-model="editForm.name" placeholder="请输入名称" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="封面" prop="cover">
              <el-input style="width: 100%;" :size="componentSize" v-model="editForm.cover" placeholder="请输入封面" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="科目" prop="subjectId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.subjectId" placeholder="请输入科目" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门" prop="departmentId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.departmentId" placeholder="请输入部门" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="讲师" prop="teacherId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.teacherId" placeholder="请输入讲师" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预算" prop="budget">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.budget" placeholder="请输入预算" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input style="width: 100%;" :size="componentSize" v-model="editForm.remark" placeholder="请输入备注" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模式" prop="mode">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.mode" placeholder="请输入模式" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展现样式" prop="displayStyle">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.displayStyle" placeholder="请输入展现样式" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习进度" prop="learningRate">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.learningRate" placeholder="请输入学习进度" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学分奖励" prop="gradeReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.gradeReward" placeholder="请输入学分奖励" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书奖励" prop="certificateReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.certificateReward" placeholder="请输入证书奖励" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防挂机" prop="antiHang">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.antiHang" placeholder="请输入防挂机" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防拖拽" prop="antiDrag">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.antiDrag" placeholder="请输入防拖拽" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="倍速播放" prop="timesSpeed">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.timesSpeed" placeholder="请输入倍速播放" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人id" prop="operatorId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.operatorId" placeholder="请输入操作人id" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识1：有效 -1：被删除" prop="state">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.state" placeholder="请输入标识1：有效 -1：被删除" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间" prop="updateTime">
              <el-date-picker style="width: 100%;" :size="componentSize"
                v-model="editForm.updateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                align="right"
                placeholder="选择日期时间"
                :picker-options="pickerOptions" clearable>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateProject">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        courseIds: [],
        subjectTreeProps: {
          value: "id",
          label: "name",
          children: "children",
        },
        fileAction: `${process.env.BASE_URL}/project/uploadFile`,
        tableLoading: false,
        blockAddProject: false,
        blockEditProject: false,
        blockDeleteProject: false,
        blockBatchDeleteProject: false,
        page: {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
            sortName: 'id',
          sortOrder: 'asc'
        },
        componentSize: '',
        addFormDialogWidth: '',
        detailFormDialogWidth: '',
        editFormDialogWidth: '',
        addFormVisible: false,
        detailFormVisible: false,
        editFormVisible: false,
        studentFormVisible: false,
        importFormVisible: false,
        searchForm: {
          name: null,
          subjectId: null,
          departmentId: null,
          teacherId: null,
        },
        addForm: {
          id: null,
          name: null,
          cover: null,
          subjectId: null,
          departmentId: null,
          teacherId: null,
          budget: null,
          remark: null,
          mode: null,
          displayStyle: null,
          learningRate: null,
          gradeReward: null,
          certificateReward: null,
          antiHang: null,
          antiDrag: null,
          timesSpeed: null,
          createTime: null,
          operatorId: null,
          state: null,
        },
        addFormRules: {
        id: [{
          required: true,
          message: '请输入id',
          trigger: 'blur'
        }],
        name: [{
          required: false,
          message: '请输入名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 255,
          message: '名称长度在0-255个字'
        }],
        cover: [{
          required: false,
          message: '请输入封面',
          trigger: 'blur'
        }, {
          min: 0,
          max: 255,
          message: '封面长度在0-255个字'
        }],
        subjectId: [{
          required: false,
          message: '请输入科目',
          trigger: 'blur'
        }],
        departmentId: [{
          required: false,
          message: '请输入部门',
          trigger: 'blur'
        }],
        teacherId: [{
          required: false,
          message: '请输入讲师',
          trigger: 'blur'
        }],
        budget: [{
          required: false,
          message: '请输入预算',
          trigger: 'blur'
        }],
        remark: [{
          required: false,
          message: '请输入备注',
          trigger: 'blur'
        }, {
          min: 0,
          max: 255,
          message: '备注长度在0-255个字'
        }],
        mode: [{
          required: false,
          message: '请输入模式',
          trigger: 'blur'
        }],
        displayStyle: [{
          required: false,
          message: '请输入展现样式',
          trigger: 'blur'
        }],
        learningRate: [{
          required: false,
          message: '请输入学习进度',
          trigger: 'blur'
        }],
        gradeReward: [{
          required: false,
          message: '请输入学分奖励',
          trigger: 'blur'
        }],
        certificateReward: [{
          required: false,
          message: '请输入证书奖励',
          trigger: 'blur'
        }],
        antiHang: [{
          required: false,
          message: '请输入防挂机',
          trigger: 'blur'
        }],
        antiDrag: [{
          required: false,
          message: '请输入防拖拽',
          trigger: 'blur'
        }],
        timesSpeed: [{
          required: false,
          message: '请输入倍速播放',
          trigger: 'blur'
        }],
        operatorId: [{
          required: false,
          message: '请输入操作人id',
          trigger: 'blur'
        }],
        state: [{
          required: false,
          message: '请输入标识1：有效 -1：被删除',
          trigger: 'blur'
        }],
        },
        detailForm: {
          id: null,
          name: null,
          cover: null,
          subjectId: null,
          departmentId: null,
          teacherId: null,
          budget: null,
          remark: null,
          mode: null,
          displayStyle: null,
          learningRate: null,
          gradeReward: null,
          certificateReward: null,
          antiHang: null,
          antiDrag: null,
          timesSpeed: null,
          operatorId: null,
          state: null,
          updateTime: null,
        },
        editForm: {
          id: null,
          name: null,
          cover: null,
          subjectId: null,
          departmentId: null,
          teacherId: null,
          budget: null,
          remark: null,
          mode: null,
          displayStyle: null,
          learningRate: null,
          gradeReward: null,
          certificateReward: null,
          antiHang: null,
          antiDrag: null,
          timesSpeed: null,
          operatorId: null,
          state: null,
          updateTime: null,
        },
        editFormRules: {
          id: [{
            required: true,
            message: '请输入id',
            trigger: 'blur'
          }],
          name: [{
            required: false,
            message: '请输入名称',
            trigger: 'blur'
          }, {
            min: 0,
            max: 255,
            message: '名称长度在0-255个字'
          }],
          cover: [{
            required: false,
            message: '请输入封面',
            trigger: 'blur'
          }, {
            min: 0,
            max: 255,
            message: '封面长度在0-255个字'
          }],
          subjectId: [{
            required: false,
            message: '请输入科目',
            trigger: 'blur'
          }],
          departmentId: [{
            required: false,
            message: '请输入部门',
            trigger: 'blur'
          }],
          teacherId: [{
            required: false,
            message: '请输入讲师',
            trigger: 'blur'
          }],
          budget: [{
            required: false,
            message: '请输入预算',
            trigger: 'blur'
          }],
          remark: [{
            required: false,
            message: '请输入备注',
            trigger: 'blur'
          }, {
            min: 0,
            max: 255,
            message: '备注长度在0-255个字'
          }],
          mode: [{
            required: false,
            message: '请输入模式',
            trigger: 'blur'
          }],
          displayStyle: [{
            required: false,
            message: '请输入展现样式',
            trigger: 'blur'
          }],
          learningRate: [{
            required: false,
            message: '请输入学习进度',
            trigger: 'blur'
          }],
          gradeReward: [{
            required: false,
            message: '请输入学分奖励',
            trigger: 'blur'
          }],
          certificateReward: [{
            required: false,
            message: '请输入证书奖励',
            trigger: 'blur'
          }],
          antiHang: [{
            required: false,
            message: '请输入防挂机',
            trigger: 'blur'
          }],
          antiDrag: [{
            required: false,
            message: '请输入防拖拽',
            trigger: 'blur'
          }],
          timesSpeed: [{
            required: false,
            message: '请输入倍速播放',
            trigger: 'blur'
          }],
          operatorId: [{
            required: false,
            message: '请输入操作人id',
            trigger: 'blur'
          }],
          state: [{
            required: false,
            message: '请输入标识1：有效 -1：被删除',
            trigger: 'blur'
          }],
        },
        importForm: {},
        searchFormLabelWidth: '0px',
        formLabelWidth: '80px',
        selection: '',
        multipleSelection: '',
        ids: [],
        rangePickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
        fileList: [],
        loading: false,
        permissions: []
      }
    },
    methods: {
      downloadFile() {
        const url = "./static/file/学习项目人员导入.xlsx";
        window.open(url);
      },
      setComponentSize() {
        if(document.body.clientWidth <= 992) {
          this.componentSize = 'mini'
          return
        }
        if(document.body.clientWidth <= 1200) {
          this.componentSize = 'small'
          return
        }
        if(document.body.clientWidth <= 1920) {
          this.componentSize = 'medium'
          return
        }
      },
      setDialogWidth() {
        if(document.body.clientWidth > 1366) {
          this.addFormDialogWidth = '60%'
        }else {
          this.addFormDialogWidth = '75%'
        }
        if(document.body.clientWidth > 1366) {
          this.detailFormDialogWidth = '60%'
        }else {
          this.detailFormDialogWidth = '75%'
        }
        if(document.body.clientWidth > 1366) {
          this.editFormDialogWidth = '60%'
        }else {
          this.editFormDialogWidth = '75%'
        }
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize
        this.pageList()
      },
      currentChange(pageNumber) {
        this.page.pageNumber = pageNumber
        this.pageList()
      },
      selectionChange(val) {
        this.multipleSelection = val
        this.ids = []
        val.forEach(e => this.ids.push({id: e.id}))
      },
      getProjectDetail() {
        this.api.project.getProjectDetail({
          id: this.selection
        }).then(result => {
          if(result.success) {
            this.detailForm = result.data
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getProjectById() {
        this.api.project.getProjectById(this.selection)
        .then(result => {
          if(result.success) {
            this.editForm = result.data
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      pageList() {
        this.tableLoading = true
        this.searchForm.pageSize = this.page.pageSize
        this.searchForm.pageNumber = this.page.pageNumber
        this.searchForm.sortName = this.page.sortName
        this.searchForm.sortOrder = this.page.sortOrder
        this.api.project.pageList(this.searchForm).then(result => {
          this.page.rows = result.data.records
          this.page.total = result.data.total
          this.tableLoading = false
        }).catch(error => {
          console.log(error)
        })
      },
      addProject() {
        if(this.blockAddProject) {
          return false
        }
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.blockAddProject = true
            this.api.project.addProject(this.addForm).then(result => {
              if (result.success) {
                this.$message.success(result.message)
                this.addFormVisible = false
              }else {
                this.$message.error(result.message)
              }
              this.blockAddProject = false
            }).catch(error => {
              this.blockAddProject = false
              console.log(error)
            })
          } else {
            return false
          }
        })
      },
      updateProject() {
        if(this.blockEditProject) {
          return false
        }
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.blockEditProject = true
            this.api.project.updateProject(this.editForm).then(result => {
              if(result.success) {
                this.$message.success(result.message)
                this.editFormVisible = false
                this.pageList()
              }else {
                this.$message.error(result.message)
              }
              this.blockEditProject = false
            }).catch(error => {
              this.blockEditProject = false
              console.log(error)
            })
          } else {
            return false
          }
        })
      },
      deleteProject(row) {
        if(this.blockDeleteProject) {
          return false
        }
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.blockDeleteProject = true
          this.api.project.deleteProject([{
            id: row.id
          }]).then(result => {
            if(result.success) {
              this.$message.success(result.message)
              this.pageList()
            }else {
              this.$message.error(result.message)
            }
            this.blockDeleteProject = false
          }).catch(error => {
            this.blockDeleteProject = false
            console.log(error)
          })
        }).catch(() => {

        })
      },
      goToAddProject() {
        this.$router.push({
          path: "/addProject"
        });
      },
      batchDeleteProject() {
        if(this.blockBatchDeleteProject) {
          return false
        }
        if(this.ids.length === 0) {
          this.$message.error('请选择要删除的数据！')
          return false
        }
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.blockBatchDeleteProject = true
          this.api.project.deleteProject(this.ids).then(result => {
            if(result.success) {
              this.$message.success(result.message)
              this.pageList()
            }else {
              this.$message.error(result.message)
            }
            this.blockBatchDeleteProject = false
          }).catch(error => {
            this.blockBatchDeleteProject = false
            console.log(error)
          })
        }).catch(() => {

        })
      },
      reset() {
        this.$refs.searchForm.resetFields()
        this.pageList()
      },
      handleSuccess (res, file) {
        this.addForm.url = file.response.data;
      },
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error("上传文件大小不能超过 1024kb!");
        }
        return isLt2M;
      },
      exportExcel() {
        this.loading = true
        this.api.project.exportExcel(this.searchForm).then(result => {
          location.href = result.data
          this.loading = false
        }).catch(error => {
          console.log(error)
        })
      },
      importData() {
        this.api.project.importData(this.importForm.rows).then(result => {
          if(result.success) {
            this.$message.success(result.message)
            this.importFormVisible = false
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      active(row) {
        this.api.project.active(row).then(result => {
          if(result.success) {
            this.$message.success(result.message)
          }else {
            this.$message.error(result.message)
          }
          this.pageList()
        }).catch(error => {
          console.log(error)
        })
      },
      getPermissionList() {
        let user = JSON.parse(localStorage.user)
        user.resources.forEach(e => {
          e.resources.forEach(a => {
            a.resources.forEach(x => this.permissions.push(x.url))
          })
        })
      },
      upload(file) {
        this.api.upload.stsToken().then(result => {
          if(!result.success) {
            this.$message.error(result.message)
          }
          if (file.file.size / 1024 / 1024 > 1) {
            this.$message.error("图片大小不能超过1M");
          } else {
            this.api.upload.uploadOSS(file, result.data, 'project').then(result => {

            })
          }
        })
      }
    },
    watch: {
      'addFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.addForm.resetFields()
          this.pageList()
        } else {
        }
      },
      'detailFormVisible': function (newVal) {
        if (newVal) {
          let loading = this.$loading.service({
            text: '请稍等',
            target: document.querySelector('.detail-form-dialog')
          })
          this.getProjectDetail()
          loading.close()
        }
      },
      'editFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.editForm.resetFields()
          this.pageList()
        } else {
          let loading = this.$loading.service({
            text: '请稍等',
            target: document.querySelector('.edit-form-dialog')
          })
          this.getProjectById()
          loading.close()
        }
      }
    },
    mounted() {
      this.setComponentSize()
      this.setDialogWidth()
      // this.getPermissionList()
      this.pageList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/project/index.vue